import Vue from "vue";
import Roles from "@/roles";
import Leaflet from "leaflet";
import authentication from "./authentication";
import errorHelper from "@/components/helpers/errorhelper";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import lodash from "lodash";
import store from "./vuex/store";
import moment from "moment-timezone";
import axios from "axios";
import vuetify from "./plugins/vuetify";
import Vuetify from "vuetify/lib";
import {
  VAlert,
  VApp,
  VAvatar,
  VBadge,
  VBtn,
  VBtnToggle,
  VCard,
  VCheckbox,
  VChip,
  VDataTable,
  VDatePicker,
  VDialog,
  VDivider,
  VExpansionPanel,
  VFooter,
  VForm,
  VIcon,
  VList,
  VMenu,
  VNavigationDrawer,
  VProgressCircular,
  VProgressLinear,
  VRadio,
  VRadioGroup,
  VResponsive,
  VSelect,
  VSlider,
  VSnackbar,
  VSpeedDial,
  VStepper,
  VSubheader,
  VSwitch,
  VTabs,
  VTextarea,
  VTextField,
  VTimePicker,
  VToolbar,
  VTooltip
} from "vuetify/lib";

import "../node_modules/leaflet/dist/leaflet.css";
import App from "./App";
import router from "./router";
import authModule, {
  NAMESPACE as AUTH_NAMESPACE
} from "./authentication/store/index";
import "@/styles/global.scss";
axios.interceptors.response.use(
  response => {
    return response;
  },
  function(error) {
    if (error.response) {
      errorHelper.showError(error.response);
      return Promise.reject(error.response);
    } else {
      errorHelper.showError(error);
      return Promise.reject(error);
    }
  }
);
if (!(store && store.state && store.state[AUTH_NAMESPACE])) {
  store.registerModule(AUTH_NAMESPACE, authModule);
}
Vue.filter("formatWholeDate", function(value) {
  if (value) {
    return moment(String(value)).format("MM/DD/YYYY");
  }
});
Vue.filter("formatMonthDate", function(value) {
  if (value) {
    return moment(String(value)).format("MMMM YYYY");
  }
});
Vue.use(lodash, Leaflet);
Vue.use(vuetify, {
  components: {
    VAlert,
    VApp,
    VAvatar,
    VBadge,
    VBtn,
    VBtnToggle,
    VCard,
    VCheckbox,
    VChip,
    VDataTable,
    VDatePicker,
    VDialog,
    VDivider,
    VExpansionPanel,
    VFooter,
    VForm,
    VIcon,
    VList,
    VMenu,
    VNavigationDrawer,
    VProgressCircular,
    VProgressLinear,
    VRadio,
    VRadioGroup,
    VResponsive,
    VSelect,
    VSlider,
    VSnackbar,
    VSpeedDial,
    VStepper,
    VSubheader,
    VSwitch,
    VTabs,
    VTextarea,
    VTextField,
    VTimePicker,
    VToolbar,
    VTooltip
  }
});
Vue.config.productionTip = false;

export default new Vuetify({});
Vue.prototype.$roleDefs = Roles;
Vue.config.productionTip = false;
Vue.prototype.$registerVuexModule = function(ns, mod) {
  if (!(this.$store && this.$store.state && this.$store.state[ns])) {
    this.$store.registerModule(ns, mod);
  }
};
Vue.prototype.$logOut = function() {
  authentication.signOut();
};
Vue.prototype.$goHome = function() {
  this.$router.push({ path: `/` });
};
Vue.prototype.$isInRole = function(roles) {
  var userRoles = this.$store.getters[AUTH_NAMESPACE + "/groups"];
  if (
    userRoles.indexOf(Roles.ALLIANCE) > -1 &&
    roles.indexOf(Roles.ALLIANCE) === -1
  )
    this.$router.push({ path: `/alliance` });
  return this.$store
    .dispatch(`${AUTH_NAMESPACE}/CHECK_ROLES`, roles)
    .then(x => {
      return x;
    });
};
var app;
authentication.initialize().then(_ => {
  app = new Vue({
    vuetify: new Vuetify(),
    el: "#app",
    router,
    store,
    components: {
      App
    },
    template: "<App/>"
  });
  window.app = app;
});
